import { createContext, useContext } from 'react'

/**
 * Экраны, на которых автор смотрит урок на холсте, — ОДИН источник размеров
 * (в «телефонных» пикселях, холст масштабирует их под место). Телефон — макет
 * 390×760; повёрнутый телефон — он же боком; ПК — широкий экран той же высоты,
 * в котором плеер 16:9 заполняет место между полоской прогресса и кнопкой.
 */
export type PreviewViewport = 'phone' | 'phoneLandscape' | 'desktop' | 'thumbnail'

export const VIEWPORTS: Record<PreviewViewport, { width: number; height: number }> = {
  phone: { width: 390, height: 760 },
  phoneLandscape: { width: 760, height: 390 },
  desktop: { width: 1052, height: 760 },
  // Миниатюра в ленте блоков: телефон без полоски прогресса и «Далее»
  // (760 − 64 сверху − 96 снизу) — карточка ниже и шире.
  thumbnail: { width: 390, height: 600 },
}

/** Экран, на котором сейчас рисуется превью (ставит холст редактора). */
export const PreviewViewportContext = createContext<PreviewViewport>('phone')

/**
 * Повёрнутый телефон — полноэкранный ролик, как в настоящем плеере: без
 * крестика, полоски прогресса и «Далее».
 */
export const useIsImmersiveViewport = () => useContext(PreviewViewportContext) === 'phoneLandscape'
